import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, AuthenticationService, AddQuestionService } from '../../_services/index';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import {Location} from '@angular/common';

export class Question {
  question_text: string = '' ;
  component: number;
  description: number = 1;
  option1: string = '';
  option2: string = '';
  option3: string = '';
  option4: string = '';
}

@Component({
  selector: 'app-add-question',
  templateUrl: './add-question.component.html',
  styleUrls: ['./add-question.component.css']
})
export class AddQuestionComponent implements OnInit {

 loading = false;
 questionForm: FormGroup;
 cid: number;
 components: Object[] = [{name:'Capacity',id:1},
    {name:'Policy',id:2},
    {name:'Finance',id:4},
    {name:'Resilience',id:5},
    {name:'Gender',id:6},
    {name:'Integrity',id:7}]; descriptions: number[] = [1,2,3,4];
  question_var = new Question();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private questionService: AddQuestionService,
    private _location: Location) {
      this.route.params.subscribe( params => { this.cid=params.cid} );
      this.question_var.component=this.cid;
      this.questionForm = this.createFormGroupWithBuilderAndModel(formBuilder);
     }

  ngOnInit() {
  }

  createFormGroupWithBuilderAndModel(formBuilder: FormBuilder) {
    return formBuilder.group(this.question_var);
  }

  onSubmit() {
    this.loading = true;
    // Make sure to create a deep copy of the form-model
    const result: Question = Object.assign({}, this.questionForm.value);

    // Do useful stuff with the gathered data
    //save it into backend
    this.questionService.create(result)
    .subscribe(
        data => {
          this.loading = false;
          this._location.back();
        },
        error => {
            this.alertService.error(error);
            this.loading = false;
        });
  }
  revert() {
    // Resets to provided model
    this.questionForm.reset(this.question_var);
  }
}



// WEBPACK FOOTER //
// ./src/app/sdg/add-question/add-question.component.ts